<template>
    <div class="relative w-full min-h-screen flex flex-col items-center justify-center text-center px-4 bg-black">
        <Head title="Page Not Found" />
        <img src="/storage/webp/TSKW%20Scrolling-1920x1080.webp" alt="" class="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div class="relative z-10 text-slate-200">
            <h1 class="text-8xl font-bold tracking-wide mb-0 text-white">{{ status }}</h1>
            <p class="text-2xl font-bold mb-8">{{ message }}</p>
            <p class="text-xl">It appears you've wandered away from the gallery.</p>
            <Link href="/" class="uppercase text-xs font-light tracking-widest border-b border-gray-300 pb-1 text-white">
                Back to Home
            </Link>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'

export default {
    name: "ErrorPage",
    components: { Head, Link },
    props: ['status'],
    computed: {
        message() {
            return {
                403: 'Forbidden.',
                404: 'Page not found.',
                419: 'Page expired, please try again.',
                500: 'Something went wrong.',
                503: 'Down for maintenance.',
            }[this.status] || 'An error occurred.';
        }
    }
}
</script>
